import { createContext, useContext } from "react";

export const IntelCtx = createContext(null);

export function useIntel() {
  const v = useContext(IntelCtx);
  if (!v) throw new Error("useIntel must be used inside IntelLayout");
  return v;
}
